var _clipPath, _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbAppIconEditSequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "TB-APP_icon_edit-sequence",
    width: 22.002,
    height: 19.79,
    viewBox: "0 0 22.002 19.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    d: "m46.23 60.28-1.5-1.5a.36.36 0 0 0-.51 0l-1.07 1.07 2.02 2.02 1.07-1.07a.384.384 0 0 0-.01-.52zm-2.25 2.76-2.02-2.02-6.45 6.46-.25 2.27 2.27-.25zm3.43-1.07-9.12 9.12-3.14.35a1.433 1.433 0 0 1-1.58-1.58l.35-3.14 9.12-9.12a2.016 2.016 0 0 1 2.87 0l1.5 1.5a2.034 2.034 0 0 1 0 2.87zm-5.44 7.01 1.11-1.11a.284.284 0 0 1 .48.2v5.05a1.673 1.673 0 0 1-1.67 1.67H29.67A1.673 1.673 0 0 1 28 73.12V60.89a1.673 1.673 0 0 1 1.67-1.67h9.5a.283.283 0 0 1 .2.48l-1.11 1.11a.28.28 0 0 1-.2.08h-8.39v12.22h12.22v-3.94a.27.27 0 0 1 .08-.19z",
    "data-name": "Path 1185",
    style: {
      stroke: "#fff"
    },
    transform: "translate(-28 -57)"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6311",
    d: "M0 0h30v30H0z",
    "data-name": "Rectangle 6311"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-4{fill:#333}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11792",
    "data-name": "Group 11792",
    style: {
      clipPath: "url(#clip-path)"
    },
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11791",
    "data-name": "Mask Group 11791",
    style: {
      clipPath: "url(#clip-path-2)"
    },
    transform: "translate(-7 -6.134)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6310",
    d: "M0 0h30v27.78H0z",
    className: "cls-4",
    "data-name": "Rectangle 6310",
    transform: "translate(2 1.134)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    d: "M2.462 5H1v11.7a1.467 1.467 0 0 0 1.462 1.46h11.7V16.7h-11.7z",
    className: "cls-4",
    "data-name": "Path 1187",
    transform: "translate(-1 1.63)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbAppIconEditSequence);
export default __webpack_public_path__ + "static/media/tb_app_icon_edit_sequence.9506ea1c13a1408615ad55127e2707f0.svg";
export { ForwardRef as ReactComponent };